var localCoordinates = new Object();


function InitializeHomeSearchForm()
{
    $('#resetFilters, #resetFiltersError').on('click', function () {
        $('.slider').each(function () {
            var min = $(this).attr('min');
            var max = $(this).attr('max');
            var slider = $(this).data("ionRangeSlider");
            slider.update({
                from: min,
                to: max
            });
        });

        if ($('#bedroomDropDown option:selected')) {
            $("#bedroomDropDown option:selected").removeAttr("selected");
            $("#bedroomDropDown option:first").attr("selected", true);
        }
        
        if ($('#bathroomDropDown option:selected')) {
            $("#bathroomDropDown option:selected").removeAttr("selected");
            $("#bathroomDropDown option:first").attr("selected", true);
        }

        var urlPath = window.location.pathname;

        var isQmiSearch = false;
        var qmiSearchIndex = urlPath.indexOf('/qmi/');
        if (qmiSearchIndex != -1) {
            isQmiSearch = true;
        }

        var searchIndex = urlPath.indexOf('/search/');

        var searchUrl;
        if (searchIndex != -1) {
            searchUrl = urlPath.substring(0, searchIndex);
        }
        else {
            searchUrl = urlPath;
        }

        if (isQmiSearch) {
            searchUrl = searchUrl + "/search/qmi/1/"
        }

        window.location.href = searchUrl;
    });

    $('#btnMobileSearchFilter').on('click', function () {
        var icon = $('#mobileSearchFilterChevron');
        if ($('#basicFilter').hasClass('mobile-filter-open')) {
            icon.removeClass('fa-chevron-up');
            icon.addClass('fa-chevron-down');
            $('#basicFilter').removeClass('mobile-filter-open');
            $('.community-split-content').removeClass('mobile-filter-open');
        } else {
            icon.removeClass('fa-chevron-down');
            icon.addClass('fa-chevron-up');
            $('#basicFilter').addClass('mobile-filter-open');
            $('.community-split-content').addClass('mobile-filter-open');
        }
    });

    if ($('#filter-search').length) {
        $(function () {
            /*/ * Functions */
            function appendInputs(data, location) {
                $.each(_.sortBy(data.areas), function (i, area) {
                    if (!area.id || !area.displayName) return;
                    location.append('<option value="' + area.id + '">' + area.displayName + '</option>');
                });
            }

            function appendAjaxInputs(data, location) {
                $.each(data, function (i, displayName) {

                    if (!i || !displayName) return;
                    location.append('<option value="' + i + '">' + displayName + '</option>');
                });
            }

            function enableAllInput() {
                $('.input-container').removeClass('disabled').prop("disabled", false);
                $('.see-results').removeClass('disabled').prop("disabled", false).prop('tabindex', '0');
                $('input[type="checkbox"]').removeClass('disabled').prop("disabled", false);
                $('input[type="checkbox"]').prop('tabindex', '0');
                $('.advanced-toggle a').removeClass('disabled').prop('tabindex', '0');
                $('.see-results').prop('disabled', false);

                $('.irs-slider.from, .irs-slider.to').each(function () {
                    $(this).attr('tabindex', '0');
                });
            }

            function disableAllInput() {
                $('.input-container:not([name="area"])').addClass('disabled').prop("disabled", true);
                $('.see-results').addClass('disabled').prop("disabled", true).prop('tabindex', '-1');
                $('input[type="checkbox"]').addClass('disabled').prop("disabled", true);
                $('input[type="checkbox"]').prop('tabindex', '-1');
                $('.advanced-toggle a').not('.bottom').addClass('disabled').prop('tabindex', '-1');
                $('.see-results').prop('disabled', true);

                $('.irs-slider.from, .irs-slider.to').each(function () {
                    $(this).attr('tabindex', '-1');
                });
            }

            function scrollToTheTop() {
                /*/ * Scroll back to top*/
                var distance = $('.community-filter').offset().top;
                var offset = $('.nav--main').height();

                $('html, body').animate({
                    scrollTop: (distance - offset)
                }, 1000);
            }

            function resetFilters() {
                /*/ * Reset the sliders */
                $('.slider').each(function () {
                    var min = $(this).attr('min');
                    var max = $(this).attr('max');
                    var slider = $(this).data("ionRangeSlider");
                    slider.update({
                        from: min,
                        to: max
                    });
                });

                if ($('#bedroomDropDown option:selected')) {
                    $("#bedroomDropDown option:selected").removeAttr("selected");

                    $("#bedroomDropDown option:first").attr("selected", true);
                }

                if ($('#bathroomDropDown option:selected')) {
                    $("#bathroomDropDown option:selected").removeAttr("selected");

                    $("#bathroomDropDown option:first").attr("selected", true);
                }

                /*/ * Reset the checkboxes */
                //$('.community-filter input[type="checkbox"]').each(function () {
                //    $(this).prop('checked', false);
                //});

                //$('#show-mir').prop('checked', true);

                ///*/ * Reset text inputs */
                //$('input[type=text]').each(function () {
                //    $(this).val('');
                //});

                ///*/ * Reset selects */
                //$('select[name=commute-miles], select[name=move-in], select[name=school-district], select[name=neighborhood-select]').val('').change();

                ///*/ * Reset Mobile Filter Toggle */
                //$('.community-toggle.main').parent().toggleClass('hidden');

                ///*/ * Reset sort order */
                //$('#sort').val('').change();
                //$('#distance-option').prop('disabled', true);

                ///*/ * Scroll back to top */
                //scrollToTheTop();
            }

            function getSchoolDistricts() {
                $('select[name=school-district]').parent().addClass('disabled').prop('disabled', true);
                if ($('#region-select').val()) {
                    var term = $('#region-select').val();
                    /*if ($('#neighborhood-select').val()) { */
                    /*    term = $('#neighborhood-select').val(); */
                    /*}*/


                    var ServiceRequest = new Object();
                    ServiceRequest.MetroID = term;
                    var requestData = JSON.stringify(ServiceRequest);

                    /*/console.log(requestData);*/
                    $.ajax({
                        url: "/api/sitecore/community/getdistricts",
                        data: requestData,
                        contentType: "application/json;charset=utf-8",
                        method: "POST",
                        complete: (function (data) {

                            /*/console.log(data);*/

                            var responseJson = data.responseJSON;
                            /*/console.log(responseJson);*/
                            var dataSchools = responseJson;

                            appendAjaxInputs(dataSchools, $('#school-district'));


                            if (dataSchools) {
                                $('select[name=school-district]').parent().removeClass('disabled').prop('disabled', false);
                            } else {
                                $('select[name=school-district]').parent().addClass('disabled').prop('disabled', true);
                            }


                            var selectedVal = $('#school-district').attr("data-selected-id");
                            if (selectedVal != null & selectedVal != "") {
                                $('#school-district').val(selectedVal);
                                $('#school-district').attr("data-selected-id", "");
                            }
                        })
                    });

                    /*/*$.getJSON("/data/districts/" + term + ".json", function (data) { */
                    /*/*    appendInputs(data, $('#school-district')); */
                    /*/*}).always(function (data) { */
                    /*/*    if (data.areas) { */
                    /*/*        $('select[name=school-district]').parent().removeClass('disabled').prop('disabled', false); */
                    /*/*    } else { */
                    /*/*        $('select[name=school-district]').parent().addClass('disabled').prop('disabled', true); */
                    /*/*    } */
                    /*/*}); */
                }
            }

            /*/ * Commute distance variance */
            $('#commute').on('change', function () {
                if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test($(this).val())) {
                    $('#distance-option').prop('disabled', false);
                } else {
                    if ($('#sort').val() == 'distance') $('#sort').val('').change();
                    $('#distance-option').prop('disabled', true);
                }
            });

            /*/ * Reset filter button */
            $('a.reset-filters').on('click tap', function () {
                /*/ * Close advanced area */
                $('.advanced-toggle a').first().fadeToggle('fast', function () {
                    $('.see-results').first().toggleClass('hidden');
                    $('.advanced').fadeToggle('fast', function () {
                        if (!$('#advanced').is(':visible')) {
                            scrollToTheTop();
                        }
                    });
                });
                resetFilters();
            });

            if ($('a.reset-filters-short').length) {
                $('a.reset-filters-short').on('click tap', function () {
                    resetFilters();
                });
            }

            /*/ * Advanced toggle button */
            $('.advanced-toggle a').on('click tap', function (e) {
                if (e && $('.advanced-toggle a').first().hasClass('disabled') && $('.advanced').is(":hidden")) return false;
                $('.community-toggle.main').parent().toggleClass('hidden');
                $('.advanced-toggle a').first().fadeToggle('fast', function () {
                    $('.see-results').first().parent().toggleClass('hidden');
                    $('.advanced').fadeToggle('fast', function () {

                        if (!$('#advanced').is(':visible')) {
                            scrollToTheTop();
                        }
                    });
                });
            });

            $('#region-select').on('change', function () {
                var neighborhoodSelect = $('#neighborhood-select');
                neighborhoodSelect.prop('disabled', true);
                neighborhoodSelect.find("option").first().nextAll().remove();

                var schoolDistrict = $('select[name=school-district]');
                schoolDistrict.val('').change();
                schoolDistrict.parent().addClass('disabled').prop('disabled', true);
                schoolDistrict.find('option').first().nextAll().remove();

                var value = $(this).val();
                if (value !== '') {
                    enableAllInput();

              

                    var ServiceRequest = new Object();
                    ServiceRequest.MetroID = value;
                    var requestData = JSON.stringify(ServiceRequest);

                   /*/*console.log(requestData); */
                    $.ajax({
                        url: "/api/sitecore/community/getneighborhoods",
                        data: requestData,
                        contentType: "application/json;charset=utf-8",
                        method: "POST",
                        complete: (function (data) {
                           
                            /*/console.log(data); */

                            var responseJson = data.responseJSON;
                            /*/console.log(responseJson); */
                            dataNeighborhoods = responseJson;

                            appendAjaxInputs(dataNeighborhoods, neighborhoodSelect);
                            neighborhoodSelect.prop('disabled', false);

                            var selectedVal = $('#neighborhood-select').attr("data-selected-id");
                            if (selectedVal != null & selectedVal != "")
                            {
                                $('#neighborhood-select').val(selectedVal);
                                $('#neighborhood-select').attr("data-selected-id", "");
                            }
                            /*/*neighborhoodSelect.find("option") */
                            
                            getSchoolDistricts();
                        })
                    });



                    /*/*$.getJSON('/data/neighborhoods/' + value + '.json', function (data) { */
                    /*/*    appendInputs(dataNeighborhoods, neighborhoodSelect);              */
                    /*/*}).done(function () {                                                 */
                    /*/*    neighborhoodSelect.prop('disabled', false);                       */
                    /*/*}).always(function () {                                               */
                    /*/*    getSchoolDistricts();                                             */
                    /*/*});                                                                   */

                } else {
                    disableAllInput();
                    $('.see-results').addClass('disabled').prop("disabled", true).prop('tabindex', '-1');
                }
            });

            /*/ * Handle pageload pre-select */
            $('#region-select').change();

            $('#neighborhood-select').on('change', function () {
                var schoolDistrict = $('select[name=school-district]');
                schoolDistrict.val('').change();
                schoolDistrict.parent().addClass('disabled').prop('disabled', true);
                schoolDistrict.find('option').first().nextAll().remove();
                getSchoolDistricts();
            });

            /*/ * Show on mobile */
            $('.community-toggle a').on('click tap', function () {
                $('.community-toggle').first().toggleClass('hidden');
                $('.community-filter').first().toggleClass('hide-for-small-only');
                if ($('.community-filter').first().hasClass('hide-for-small-only')) {
                    $('.advanced').addClass('hide-for-small-only');
                } else {
                    $('.advanced').removeClass('hide-for-small-only');
                }
            });

            $('.hide-filters').on('click tap', function () {
                $('.advanced-toggle a').first().fadeToggle('fast', function () {
                    $('.see-results').first().toggleClass('hidden');
                    $('.advanced').fadeToggle('fast');
                });
                $('.community-toggle.main').parent().toggleClass('hidden');
                $('.community-toggle').first().toggleClass('hidden');
                $('.community-filter').first().toggleClass('hide-for-small-only');
            });

            /*/ * https://github.com/IonDen/ion.rangeSlider */
            $('#pricerange-slider').ionRangeSlider({
                type: "double",
                prefix: "$",
                min: $('#pricerange-slider').attr("min"),
                max: $('#pricerange-slider').attr("max"),
                from: $('#pricerange-slider').attr("data-from"),
                to: $('#pricerange-slider').attr("data-to"),
                step: 25000,
                prettify_separator: ',',
                grid: false,
                hide_min_max: true,
                force_edges: true,
                keyboard: true
            });

            $('#sqft-slider').ionRangeSlider({
                type: "double",
                postfix: " sq. ft.",
                min: $('#sqft-slider').attr("min"),
                max: $('#sqft-slider').attr("max"),
                from: $('#sqft-slider').attr("data-from"),
                to: $('#sqft-slider').attr("data-to"),
                step: 250,
                prettify_separator: ',',
                grid: false,
                hide_min_max: true,
                force_edges: true,
                keyboard: true
            });

            $('#moveindate-slider').ionRangeSlider({
                type: "double",
                postfix: "Months",
                min: 0,
                max: 12,
                from: $('#moveindate-slider').attr("min"),
                to: $('#moveindate-slider').attr("max"),
                step: 3,
                prettify_separator: ',',
                grid: false,
                hide_min_max: true,
                force_edges: true,
                keyboard: true
            });

            $('#payment-slider').ionRangeSlider({
                type: "double",
                prefix: "$",
                min: 750,
                max: 5000,
                from: $('#payment-slider').attr("min"),
                to: $('#payment-slider').attr("max"),
                step: 250,
                prettify_separator: ',',
                grid: false,
                hide_min_max: true,
                force_edges: true,
                keyboard: true
            });

            $('.input-container:not(.disabled) .irs-slider.from, .input-container:not(.disabled) .irs-slider.to').each(function () {
                $(this).attr('tabindex', '-1');
            });

            $('.input-container').on('keyup', function (e) {
                var code = (e.keyCode ? e.keyCode : e.which);
                if (code == 9 && $('.irs-slider:focus').length) {
                    $('.irs-slider:focus').click();
                }
            });
        });


      

    }

}

function InitializeHomeSearchEvents() {

    $("#btnSearchHomes").on('click', function (e) {
        e.preventDefault();

        $(this).attr("disabled", "disabled");
        SearchCommunitiesFromMetroPage();
    });

    if ($("#filter-search").length > 0)
    {

        InitalizeGeoServices();

        $("#btnLiveNowSearch").click(function (e) {
            e.preventDefault();
            SearchCommunitiesFromLiveNowPage();
        });
       
        $("#sort").change(function (e) {
            
            var sortByVal = $("#sort").val();
            /*/*if (sortByVal != "") { */
            /*/*    searchParams.sb = sortByVal; */
            /*/*} */

            if (window.location.href.indexOf('?') == -1)
            {
                window.location.href = window.location.href + "?sb=" + sortByVal;
            }
            else {
                if (window.location.href.indexOf("sb=") == -1)
                {
                    window.location.href = window.location.href + "&sb=" + sortByVal;
                }
                else {
                   
                    var url = removeURLParameter( window.location.href, "sb");
                    if (url.indexOf('?') == -1)
                    {
                        window.location.href = url + "?sb=" + sortByVal;
                    }
                    else {
                        window.location.href = url + "&sb=" + sortByVal;
                    }
                  
                }
               
            }   

          /*  SearchCommunitiesFromMetroPage(); */
        });

        $(".qmisearch").click(function (e) {

            var sortByVal = "1";
            /*/*if (sortByVal != "") { */
            /*/*    searchParams.sb = sortByVal; */
            /*/*}*/

            if (window.location.href.indexOf('?') == -1) {
                window.location.href = window.location.href + "?sqmi=" + sortByVal;
            }
            else {
                if (window.location.href.indexOf("sqmi=") == -1) {
                    window.location.href = window.location.href + "&sqmi=" + sortByVal;
                }
                else {

                    var url = removeURLParameter(window.location.href, "sqmi");
                    if (url.indexOf('?') == -1) {
                        window.location.href = url + "?sqmi=" + sortByVal;
                    }
                    else {
                        window.location.href = url + "&sqmi=" + sortByVal;
                    }

                }

            }

            /*/  SearchCommunitiesFromMetroPage();*/
        });
      
    }
     
}

function SearchCommunitiesFromMetroPage() {

    var selectedMetro = $("#region-select").val();
    var searchUrl;
    if (selectedMetro) {
        searchUrl = $("#region-select optgroup option[value='" + selectedMetro + "']").attr("data-url");
    }
    else {
        var urlPath = window.location.pathname;
        var searchIndex = urlPath.indexOf('/search/');

        if (searchIndex != -1) {
            searchUrl = urlPath.substring(0, searchIndex);
        }
        else {
            searchUrl = urlPath;
        }
    }
    
    /*/*Add QuerySTring Parameters */
    var searchParams = new Object();

    var urlPathName = window.location.pathname;
    var qmiSearchIndex = urlPathName.indexOf('/qmi/');
    if (qmiSearchIndex != -1) {
        searchParams.qmi = 1;
    }

    /*/MULTIVALUE */
    /*/Number of Bedrooms */
    var numberofBedroomsVal = $('#bedroomDropDown').val();
    if (numberofBedroomsVal) {
        searchParams.bed = numberofBedroomsVal;
    }

    /*/Number of Bathroom */
    var numberofBathroomVal = $('#bathroomDropDown').val();
    if (numberofBathroomVal) {
        searchParams.bath = numberofBathroomVal;
    }

    ///*/Number of Garages */
    //var numberofGaragesVal = $('#garageDropDown').val();
    //if (numberofGaragesVal) {
    //    searchParams.garage = numberofGaragesVal;
    //}

    ///*/Number of Stories*/
    //var numberofStoriesVal = $('#storyDropDown').val();
    //if (numberofStoriesVal) {
    //    searchParams.story = numberofStoriesVal;
    //}


    /*/RANGES*/
    /*//Price Range */
    var priceRangeLowSliderVal = $('#pricerange-slider').parent('.input-container').find('.irs-from').text();
    var priceRangeMin = $('#pricerange-slider').attr('min');
    if (priceRangeLowSliderVal) {
        priceRangeLowSliderVal = priceRangeLowSliderVal.replace('$', '');
        priceRangeLowSliderVal = priceRangeLowSliderVal.replace(/,/g, '');

        var value = Number(priceRangeLowSliderVal);
        var min = Number(priceRangeMin);

        if (value && min) {
            if (value > min) {
                searchParams.pricelow = priceRangeLowSliderVal;
            }
        }
    }

    var priceRangeHighSliderVal = $('#pricerange-slider').parent('.input-container').find('.irs-to').text();
    var priceRangeMax = $('#pricerange-slider').attr('max');
    if (priceRangeHighSliderVal) {
        priceRangeHighSliderVal = priceRangeHighSliderVal.replace('$', '');
        priceRangeHighSliderVal = priceRangeHighSliderVal.replace(/,/g, '');

        var value = Number(priceRangeHighSliderVal);
        var max = Number(priceRangeMax);

        if (value && max) {
            if (value < max) {
                searchParams.pricehigh = priceRangeHighSliderVal;
            }
        }
    }
     
    /*/Square Footage */
    var squareFootageLowSliderVal = $('#sqft-slider').parent('.input-container').find('.irs-from').text();
    var squareFootageMin = $('#sqft-slider').attr('min');
    if (squareFootageLowSliderVal) {
        squareFootageLowSliderVal = squareFootageLowSliderVal.replace(' sq. ft.', '');
        squareFootageLowSliderVal = squareFootageLowSliderVal.replace(/,/g, '');

        var value = Number(squareFootageLowSliderVal);
        var min = Number(squareFootageMin);

        if (value && min) {
            if (value > min) {
                searchParams.sqftlow = squareFootageLowSliderVal;
            }
        }
    }

    var squareFootageHighSliderVal = $('#sqft-slider').parent('.input-container').find('.irs-to').text();
    var squareFootageMax = $('#sqft-slider').attr('max');
    if (squareFootageHighSliderVal != "") {
        squareFootageHighSliderVal = squareFootageHighSliderVal.replace(' sq. ft.', '');
        squareFootageHighSliderVal = squareFootageHighSliderVal.replace(/,/g, '');

        var value = Number(squareFootageHighSliderVal);
        var max = Number(squareFootageMax);

        if (value && max) {
            if (value < max) {
                searchParams.sqfthigh = squareFootageHighSliderVal;
            }
        }
    }
   
    ///*/Design Collections*/
    //if ($("#designCollections").prop("checked")) {
    //    searchParams['design collection'] = 1;
    //}

    ///*/Live Now*/
    //if ($("#live-now").prop("checked")) {
    //    searchParams['live now'] = 1;
    //}

    ///*/Coming Soon*/
    //if ($("#comingSoon").prop("checked")) {
    //    searchParams['coming soon'] = 1;
    //}

    ///*/Grand Opening*/
    //if ($("#grandOpening").prop("checked")) {
    //    searchParams['grand opening'] = 1;
    //}

    ///*/Active*/
    //if ($("#active").prop("checked")) {
    //    searchParams['active'] = 1;
    //}

    ///*/QMI Only*/
    //if ($("#qmiOnly").prop("checked")) {
    //    searchParams['qmi only'] = 1;
    //}

    if (Object.keys(searchParams).length) {

        var lastCharacter = searchUrl.substring(searchUrl.length - 1);
        if (lastCharacter !== '/') {
            searchUrl = searchUrl + '/'
        }

        searchUrl = searchUrl + 'search/';

        for (var key in searchParams) {
            searchUrl = searchUrl + key;
            searchUrl = searchUrl + '/';
            searchUrl = searchUrl + searchParams[key];
            searchUrl = searchUrl + '/';
        }

        window.location.href = searchUrl;
    }
    else {
        window.location.href = searchUrl;
    }
    console.log(searchUrl);
}


function SearchCommunitiesFromLiveNowPage() {

    var searchParams = new Object();
    /*/*SINGLE VALUE */
    /*/*Get Metro Search Url */
    var selectedMetro = $("#region-select").val();
    var searchUrl = "liveNow";
    console.log(selectedMetro);
    console.log(searchUrl);

    /*NOTE: CCordoba - 2/21/2018 The next parameters were added to accomodate the live now values that we are hidding.*/

    /*Neighborhood */
    var neighborhoodVal = $("#neighborhood-select").val();
    if (neighborhoodVal != "") {
        searchParams.nei = neighborhoodVal;
    }
    

    var metro = $("#region-select").val();
    if (metro != "") {
        searchParams.m = metro;
    }


    var community = $("#hidCommunityId").val();
    if (community != "") {
        searchParams.communityId = community;
    }

    var user = $("#hidUser").val();
    if (user != "") {
        searchParams.user = user;
    }

    /*/*Add QuerySTring Parameters */

    /*/MULTIVALUE */
    /*/Number of Bedrooms */
    var numberofBedroomsVal = "";
    $("#chklstBedrooms input:checked").each(function (item) {
        numberofBedroomsVal = numberofBedroomsVal + $(this).val() + "|";
    });
    if (numberofBedroomsVal != "") {
        searchParams.nbedrm = numberofBedroomsVal;
    }
    /*/Number of Bathroom */
    var numberofBathroomVal = "";
    $("#chklstBathrooms input:checked").each(function (item) {
        numberofBathroomVal = numberofBathroomVal + $(this).val() + "|";
    });
    if (numberofBathroomVal != "") {
        searchParams.nbthrm = numberofBathroomVal;
    }
   
    /*/RANGES*/
    /*//Price Range */
    var priceRangeSliderVal = $("#pricerange-slider").val();
    if (priceRangeSliderVal != "") {
        searchParams.pr = priceRangeSliderVal;
    }

    /*/Square Footage */
    var squareFootageSliderVal = $("#sqft-slider").val();
    if (squareFootageSliderVal != "") {
        searchParams.sqft = squareFootageSliderVal;
    }

    /*/ $('#moveindate-slider').ionRangeSlider({ */
    /*/Square Footage */
    var moveInDataSiderVal = $("#moveindate-slider").val();
    if (moveInDataSiderVal != "") {
        searchParams.mon = moveInDataSiderVal;
    }

    /*/Monthly Payment */
    var monthlyPaymentSliderVal = $("#payment-slider").val();
    if (monthlyPaymentSliderVal != "") {
        searchParams.mp = monthlyPaymentSliderVal;
    }

    /*/TOOGLES */
    /*/Show Move-IN */
    var showMoveInsVal = "";

    if ($("#show-mir").prop("checked")) {
        searchParams.sqmi = "1";
    }

    /*/LiveNow */
    var lifestyleLivingVal = "";
    if ($("#live-now").prop("checked")) {
        lifestyleLivingVal = lifestyleLivingVal + "LiVE.NOW" + "|";
    }
    if (lifestyleLivingVal != "") {
        searchParams.lsl = lifestyleLivingVal;
    }

    var sortByVal = $("#sort").val();
    if (sortByVal != "") {
        searchParams.sb = sortByVal;
    }

    console.log(searchParams);
    var querystring = jQuery.param(searchParams);
    querystring = decodeURIComponent(querystring);

    if (querystring != "") {
        searchUrl = searchUrl + "?" + querystring;
        window.location.href = searchUrl;
    }
    else {
        window.location.href = searchUrl;
    }
    console.log(searchUrl);


        /*NOTE: CCordoba - 2/21/2018 The next parameters were added to accomodate the live now values that we are hidding.*/
/** End of the NOTE: CCordoba - 2/21/2018 **/

    /*/School Distinct - Not needed for Live now */
    //var schoolVal = $("#school-district").val();
    //if (schoolVal != "") {
    //    searchParams.sch = schoolVal;
    //}
    ///*/Number of Garages */
    //var numberofGaragesVal = "";
    //$("#chklstGarages input:checked").each(function (item) {
    //    numberofGaragesVal = numberofGaragesVal + $(this).val() + "|";
    //});
    //if (numberofGaragesVal != "") {
    //    searchParams.bgar = numberofGaragesVal;
    //}

      /*/Geo - Spartial */
    //var distanceVal = $("#ddlDistance").val();
    //if (distanceVal != "") {
    //    searchParams.dis = distanceVal;
    //}
    //console.log(localCoordinates);
    //if (localCoordinates != null && localCoordinates.Latitude != null && localCoordinates.Longitude != null) {
    //    searchParams.latlong = localCoordinates.Latitude + "|" + localCoordinates.Longitude;
    //}
    //var zipCodeVal = $("#commute").val();
    //if (zipCodeVal != "") {
    //    searchParams.zip = zipCodeVal;
    //}
     
    ///*/MontereyHomes */
    //if ($("#monterey-homes").prop("checked")) {
    //    lifestyleLivingVal = lifestyleLivingVal + "Monterey" + "|";
    //}

    ///*/Active Adults */
    //if ($("#active-adult-homes").prop("checked")) {
    //    lifestyleLivingVal = lifestyleLivingVal + "Active Adult" + "|";
    //}

    //var amenitiesVal = "";
    //$(".Amenities-List input:checked").each(function (item) {
    //    amenitiesVal = amenitiesVal + $(this).val() + "|";
    //});
    //if (amenitiesVal != "") {
    //    searchParams.am = amenitiesVal;
    //}

    ///*/Number of Stories*/
    //var numberofStoriesVal = "";
    //$("#chklstStories input:checked").each(function (item) {
    //    numberofStoriesVal = numberofStoriesVal + $(this).val() + "|";
    //});
    //if (numberofStoriesVal != "") {
    //    searchParams.nstory = numberofStoriesVal;
    //}


    ///*/Move In Date */
    //var moveInDateVal = $("#ddlMoveInDate").val();
    //if (moveInDateVal != "") {
    //    searchParams.mid = moveInDateVal + "|";
    //}



}

function postURL(url, multipart) {
    var form = document.createElement("FORM");
    form.method = "POST";
    if (multipart) {
        form.enctype = "multipart/form-data";
    }
    form.style.display = "none";
    document.body.appendChild(form);
    form.action = url.replace(/\?(.*)/, function (_, urlArgs) {
        urlArgs.replace(/\+/g, " ").replace(/([^&=]+)=([^&=]*)/g, function (input, key, value) {
            input = document.createElement("INPUT");
            input.type = "hidden";
            input.name = decodeURIComponent(key);
            input.value = decodeURIComponent(value);
            form.appendChild(input);
        });
        return "";
    });
    form.submit();
}

function InitalizeGeoServices() {

    $("#commute").blur(function () {

        var zipCode = $(this).val();
        /*/console.log(zipCode); */

        if (zipCode.length > 4)
        {
            var googleUrl = "https://maps.googleapis.com/maps/api/geocode/json?address=" + zipCode + "&key=AIzaSyDZ_D79dUAf_6gvDjzOx9BTHxkw7Zz4uQk";
            $.get(googleUrl, function (data, status) {
                /*/console.log(data); */
                /*/console.log(status); */
               
                localCoordinates.Latitude = data.results[0].geometry.location.lat;
                localCoordinates.Longitude = data.results[0].geometry.location.lng;
                /*/console.log("localCoordinates"); */
                /*/console.log(localCoordinates); */
                
            });

        }

      

    })


    /*/if (navigator.geolocation) { */
    /*/           var geoLocation = navigator.geolocation.getCurrentPosition(function (position) { */
    /*/        localCoordinates.Latitude = position.coords.latitude; */
    /*/        localCoordinates.Longitude = position.coords.longitude; */
    /*/    }); */
    /*/} */
    /*/else { */
      
    /*/} */

}

$(document).ready(function () {

    InitializeHomeSearchForm()
    InitializeHomeSearchEvents();

    /*/if ($('.slick-slider')) { */
    /*/    $('.slick-slider').slick('setPosition', 0); */
    /*/} */
 
});

function removeURLParameter(url, parameter) {
    /*/prefer to use l.search if you have a location/link object */
    var urlparts= url.split('?');   
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);

        /*/reverse iteration as may be destructive */
        for (var i= pars.length; i-- > 0;) {    
            /*/idiom for string.startsWith */
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}